import { render, staticRenderFns } from "./FastPayment.vue?vue&type=template&id=2ae529c4&scoped=true"
import script from "./FastPayment.vue?vue&type=script&lang=js"
export * from "./FastPayment.vue?vue&type=script&lang=js"
import style0 from "./FastPayment.vue?vue&type=style&index=0&id=2ae529c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae529c4",
  null
  
)

export default component.exports